/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TournamentTeamSizeOption
 */
export interface TournamentTeamSizeOption {
    /**
     * Team size (1 for solo, 2 for duo, etc.)
     * @type {number}
     * @memberof TournamentTeamSizeOption
     */
    size: number;
    /**
     * Display label (e.g., "1v1", "2v2", "5v5")
     * @type {string}
     * @memberof TournamentTeamSizeOption
     */
    label: string;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentTeamSizeOption
     */
    enabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof TournamentTeamSizeOption
     */
    sortOrder: number;
}

/**
 * Check if a given object implements the TournamentTeamSizeOption interface.
 */
export function instanceOfTournamentTeamSizeOption(value: object): value is TournamentTeamSizeOption {
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('sortOrder' in value) || value['sortOrder'] === undefined) return false;
    return true;
}

export function TournamentTeamSizeOptionFromJSON(json: any): TournamentTeamSizeOption {
    return TournamentTeamSizeOptionFromJSONTyped(json, false);
}

export function TournamentTeamSizeOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentTeamSizeOption {
    if (json == null) {
        return json;
    }
    return {
        
        'size': json['size'],
        'label': json['label'],
        'enabled': json['enabled'],
        'sortOrder': json['sortOrder'],
    };
}

export function TournamentTeamSizeOptionToJSON(json: any): TournamentTeamSizeOption {
    return TournamentTeamSizeOptionToJSONTyped(json, false);
}

export function TournamentTeamSizeOptionToJSONTyped(value?: TournamentTeamSizeOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'size': value['size'],
        'label': value['label'],
        'enabled': value['enabled'],
        'sortOrder': value['sortOrder'],
    };
}

